import React, { useContext, Component, useEffect, useState } from "react";

import { GlobalStateContext } from "./App";


function ItemListProgram({ items, onSelect }) {
    return (
        <>

            <ul className="feature-list">
                {items.map((val, index) => (
                    <li className="item" key={index}>
                        <a onClick={() => onSelect(val.id_programa)}>
                            <h3>{val.programa}</h3>
                        </a>
                    </li>
                ))}
            </ul>
        </>

    );
}


export default function Programa() {
    const {
        item,
        idProgram,
        setidProgram,
        idCampus,
        setidCampus,
        idNivel,
        setidNivel,
        idFacultad,
        setidFacultad,
        visibleCount, 
        setVisibleCount,
        filtraUniversidad
    } = useContext(GlobalStateContext);

    const SelectProgram = (idProgram) => {
        setidProgram(idProgram);
    }

    const handleLoadMore = () => {
        setVisibleCount((prev) => prev + 20);
    };

    const Items = item.slice(0, visibleCount);

    return (
        <>
            <div> <strong> Resultados ( {item.length >= 0 ? item.length : 0} ) </strong></div>

            <div className="list-posec-items">
                <ul className="feature-list">
                    {Items.map((val, index) => (
                        <li className="item-prosec" key={index}>
                            <a onClick={() => SelectProgram(val.id_programa)}>
                                <h3>{val.programa}</h3>
                            </a>
                        </li>
                    ))}
                </ul>

            {visibleCount < item.length && (
                <button className="btn btn-default"  onClick={handleLoadMore}>
                    Ver más
                </button>
            )}
            </div>
       

        </>

    );

}
